import styled from 'styled-components';
import { DropzoneContainer } from '@zillow/zrs-comet';
import { Text } from '@zillow/constellation';

export const StyledDropzoneContainer = styled(DropzoneContainer)`
    && {
        display: flex;
    }

    ${Text} {
        text-transform: none;
    }

    .SpinnerContainer {
        padding: 10px;
    }
`;
